"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = AudioBar;

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _AudioPlayer = _interopRequireDefault(require("./AudioPlayer.scss"));

var _momentDurationFormat = _interopRequireDefault(require("moment-duration-format"));

function AudioBar(props) {
  var color = props.color,
      duration = props.duration,
      curTime = props.curTime,
      onTimeUpdate = props.onTimeUpdate;
  var curPercentage = curTime / duration * 100;
  var barRef = (0, _react.useRef)();
  (0, _momentDurationFormat["default"])(_moment["default"]);
  var eventListenerSet = false;
  (0, _react.useEffect)(function () {
    var bar = barRef.current;

    if (bar && !eventListenerSet) {
      eventListenerSet = true;
      bar.addEventListener('touchmove', updateTimeOnMove);
    }

    return function () {
      if (bar) {
        bar.removeEventListener('touchmove', updateTimeOnMove);
      }
    };
  });

  var updateTimeOnMove = function updateTimeOnMove(eMove) {
    eMove.preventDefault();
    var clickedTime = calcClickedTime(eMove);

    if (clickedTime) {
      onTimeUpdate(clickedTime);
    }
  };

  var formatDuration = function formatDuration(duration) {
    return _moment["default"].duration(duration, 'seconds').format('mm:ss', {
      trim: false
    });
  };

  var calcClickedTime = function calcClickedTime(event) {
    var clickPositionInPage = event.pageX;
    var bar = barRef && barRef.current ? barRef.current : null;

    if (bar) {
      var barVerticalStart = bar.getBoundingClientRect().top - 20;
      var barVerticalEnd = bar.getBoundingClientRect().bottom + 20;

      if (event.pageY < barVerticalStart || event.pageY > barVerticalEnd) {
        console.log('touchmove outside bar!');
        return null;
      }

      var barStart = bar.getBoundingClientRect().left;
      var barWidth = bar.offsetWidth;
      var clickPositionInBar = clickPositionInPage - barStart;
      var timePerPixel = duration / barWidth;
      return timePerPixel * clickPositionInBar;
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _AudioPlayer["default"].bar
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _AudioPlayer["default"].barTime
  }, formatDuration(curTime)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _AudioPlayer["default"].barProgress,
    ref: barRef,
    style: {
      background: "linear-gradient(to right, ".concat(color, " ").concat(curPercentage, "%, grey 0)")
    },
    onClick: function onClick(e) {
      return updateTimeOnMove(e);
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _AudioPlayer["default"].barProgressHandle,
    style: {
      left: "".concat(curPercentage - 2, "%")
    }
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: _AudioPlayer["default"].barTime
  }, formatDuration(duration)));
}